<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
import { Pie } from "vue-chartjs";

export default {
  name: "PieChart",
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    // Clone to plain object to avoid Vue reactivity issues with Chart.js
    const plainData = JSON.parse(JSON.stringify(this.chartData));
    this.renderChart(plainData, this.options);
  },
};
</script>

<style scoped>
canvas {
  max-height: 300px;
}
</style>
